module.exports = __webpack_public_path__ + "static/media/people-grey-icon.771a9bfa.svg";